export { default as Profile } from './Profile';
export { default as DeleteAccount } from './DeleteAccount/DeleteAccount';
